// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1gKQq","signatureButtonsRight":"ModalSign_signatureButtonsRight__BZEXe"};